module.exports = __webpack_public_path__ + "static/ballantinesEF-547ed6ff04d5310cef6516ff2ebac240.eot";